import ButtonComponent from "./button.js";
import ButtonContent from "./button-content.js";
import ButtonGroup from "./button-group.js";
export * from "./button.shared.js";
export { createButton } from "./button.js";
export { default as ButtonContext } from "./button.context.js";
const Button = ButtonComponent;
Button.Content = ButtonContent;
Button.Group = ButtonGroup;
export default Button;
